module.exports = __webpack_public_path__ + "static/media/ino_shika.946532a8.webp";